import type { ReactNode } from 'react';
import { useMemo } from 'react';
import { buildEnhancedChatApiClient } from '@trinity/chat/api';
import { ChatApiClientContext } from '@trinity/chat-components/containers/Chat/contexts.js';
import { getAuthenticatedClient, getUnauthenticatedClient } from '@/api/client';

export const ChatApiClientProvider = ({ children }: { children: ReactNode }) => {
  const client = useMemo(() => buildEnhancedChatApiClient({
    authenticatedClient: getAuthenticatedClient(),
    unauthenticatedClient: getUnauthenticatedClient(),
  }), []);

  return (
    <ChatApiClientContext.Provider value={client}>
      {children}
    </ChatApiClientContext.Provider>
  );
};
